<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
    >
      <template slot="statusSlot" slot-scope="{ row }">
        <el-button type="link" @click="showDownProgress(row)" v-if="row.status == 0">{{shop_opt_status_map[row.status]}}</el-button>
        <span v-else>{{shop_opt_status_map[row.status]}}</span>
      </template>
      <template slot="opcolsSlot" slot-scope="{ row }">
        <el-button
          type="link"
          @click="jumpDetail(row)"
          >查看明细</el-button
        >
      </template>
    </TableList>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary.js";
import tableMixins from '@mixins/table-mixins';
import { mapActions, mapMutations, mapGetters} from "vuex";

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: "supplier",
    },
  },
  mixins: [new tableMixins(176,{ refName:'search' })],
  components: {
    TableList,
  },
  data() {
    return {
      cols: [
        { prop: "startTime", attrs: { label: "操作时间" } },
        { prop: "channel", attrs: { label: "途径" } },
        { prop: "source", attrs: { label: "数据来源" }},
        {prop: "operateMode", attrs: {label: "操作方式"}},
        { prop: "status", attrs: { label: "状态" }, slot: true },
        { prop: "staffName", attrs: { label: "操作人" } },
        { prop: "total", attrs: { label: "操作总数" } },
        { prop: "successTotal", attrs: { label: "操作成功数" } },
        { prop: "failureTotal", attrs: { label: "操作失败数" } },
        { prop: "opcols", attrs: { label: "操作" }, slot: true }
      ],
    };
  },
  computed: {
    ...mapGetters(['routerPrefix']),
    shop_opt_status_map() {
      const { SHOP_OPT_STATUS_MAP }  = prod_center_dictionary;
      return SHOP_OPT_STATUS_MAP;
    }
  },
  methods: {
    ...mapActions(['publishSpeed']),
    ...mapMutations(['setCurrentPage']),
    jumpDetail(rowData) {
       if(rowData.channel != '批量修改1-5级分销价'){
        this.$router.push({
          name: `${this.routerPrefix}prod_log`,
          query:{
            id: rowData.id
          }
        })
       } else {
        this.$router.push({
          name: `${this.routerPrefix}prod_log`,
          query:{
            id: rowData.id,
            isBatchPrice: true
          }
        })
       }
    },
    showPublishSpeed(rowData) {
      this.setCurrentPage(`${this.routerPrefix}log`);
      this.publishSpeed({publishType: rowData.publishType, resultVisible: true})
    },
    // 新增中，重新弹出进度条
    showDownProgress(rowData) {
      this.$emit('show-down-progress',rowData)
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
